import React from 'react';
import styles from './ServiceCard.module.css';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';
import clsx from 'clsx';
import { FiCheck } from 'react-icons/fi';

interface Service {
  id: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  features: string[];
}

interface ServiceCardProps {
  service: Service;
  index: number;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ service, index }) => {
  const [ref, isVisible] = useIntersectionObserver<HTMLDivElement>({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <div
      ref={ref}
      className={clsx(styles.card, isVisible && styles.visible)}
      style={{ transitionDelay: `${index * 0.2}s` }}
    >
      <div className={styles.iconWrapper}>{service.icon}</div>

      <h3 className={styles.title}>{service.title}</h3>

      <p className={styles.description}>{service.description}</p>

      <ul className={styles.featureList}>
        {service.features.map((feature, idx) => (
          <li key={idx} className={styles.feature}>
            <FiCheck className={styles.checkIcon} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
